import React from "react";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "../../utils/hoc/withRouter";
import { CustomModal, Spinner, SelectKeywords } from "../common";
import { addPositionApi, updatePositionApi, getKeywordNameApi } from "./Api";

class PositionForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    this.state = {
      position: data?.position || "",
      code: data?.code || "",
      keywords: data?.keywords ? data.keywords.split(",").map(item => item.trim()).filter(Boolean) : [],
      keywordOption: [],
      search: "",
      resLoading: false,
      isAddContent: true,
    };
  }

  componentDidMount() {
    this.props.getKeywordNameApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }

  keywordsChangeHandler = (info) => {
    this.setState({ search: info });
  };

  onValidSubmit = () => {
    this.setState({ resLoading: true });
    const context = this.props.this || this.props.ctx;
    let dataObj = {
      data: {
        position: this.state.position,
        code: this.state.code,
        keywords: this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
      },
    };
    if (this.props.editData?.uuid) {
      updatePositionApi(JSON.stringify(dataObj), context, this.props.onHide, this.props.editData.uuid)
        .finally(() => this.setState({ resLoading: false }));
    } else {
      addPositionApi(JSON.stringify(dataObj), context, this.props.onHide)
        .finally(() => this.setState({ resLoading: false }));
    }
  };

  render() {
    const { resLoading } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props.editData?.uuid ? "Edit Position" : "Add Position"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
            <Col sm={6}>
              <FormElement
                valueLink={this.linkState(this, "position")}
                label="Position"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter Position",
                    disabled: !!this.props.editData?.uuid,
                  },
                }}
              />
            </Col>
            <Col sm={6}>
              <FormElement
                valueLink={this.linkState(this, "code")}
                label="Code"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter Code",
                    disabled: !!this.props.editData?.uuid,
                  },
                }}
              />
            </Col>
            <Col sm={12}>
              <SelectKeywords
                required={false}
                label="Keywords"
                placeholder={"Enter Keywords"}
                onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                selectedKeyWords={this.state.keywords}
                options={this.state.keywordOption}
                getKeys={(data) => this.setState({ keywords: data })}
              />
            </Col>
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {resLoading ? (
                <span className="d-flex align-items-center gap-12">
                  {" "}
                  <Spinner /> Saving...
                </span>
              ) : (
                "Save"
              )}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default connect(null, { getKeywordNameApi })(withRouter(PositionForm));
